const CurvedArrowLeft = ({ width = '1.2rem', height = '1.2rem' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66602 3.66602H6.44374C6.44374 3.66602 10.3326 3.66602 10.3326 7.55488C10.3326 11.4438 10.3326 11.4994 10.3326 11.4994"
      stroke="#3C3C3B"
      strokeLinecap="square"
    />
    <path d="M3.66667 6.33333L1 3.66667L3.66667 1" stroke="#3C3C3B" strokeLinecap="square" />
  </svg>
);

export default CurvedArrowLeft;
